module.exports = __webpack_public_path__ + "static/img/jpz.bea874a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/doctor/jpz.jpg
// module id = +2gO
// module chunks = 1